<template>
  <base-cell class="activity-cell">
    <div class="activity-cell__container">
      <div class="activity-cell__header">
        <div>
          <base-text
            class="clickable__client"
            @click.native="goToClient"
          >
            {{ clientFullName || name }}
          </base-text>
          <base-text
            size="xs"
            muted
          >
            {{ email || '' }}
          </base-text>
        </div>
        <!--
        <base-text
          size="xs"
          class="ml-auto"
        >
          {{ date | nicedate('small') }}
        </base-text>
        -->
      </div>
      <activity-items
        v-if="items.length > 0"
        :last-update="date"
        :items="items"
        :date-verb="dateVerb"
        :show-size="showSize"
      />
      <div v-else>
        <slot />
      </div>
    </div>
  </base-cell>
</template>

<script>
import ActivityItems from './ActivityItems';

export default {
  name: 'ActivityCell',
  components: {
    ActivityItems,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    showSize: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: '',
    },
    clientFullName: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    dateVerb: {
      type: [String, Number],
      default: 'Added',
    },
    itemId: {
      type: [String, Number],
      default: '',
    },

  },
  methods: {
    goToClient() {
      this.$router.push(`/clients/${this.itemId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-cell {
  display: block;
  &__container{
    width: 100%;
  }
  &__header {
    display: flex;
    width: 100%;
  }
}
.base-cell {
  padding: 24px 0px !important;
}
.clickable__client {
  cursor: pointer;
}
</style>
